package io.horion.cv.styles

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxHeight
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh

//val HeroContainerStyle = CssStyle {
//    base {
//        Modifier
//            .height(300.px)
//            .styleModifier { property("background-position", "center") }
//    }
//    Breakpoint.MD {
//        Modifier
//            .height(900.px)
//            .styleModifier { property("background-position", "left center") }
//    }
//}
//
//val HeroContentBoxStyle = CssStyle {
//    base {
//        Modifier.padding(top = 50.px, left = 20.px)
//    }
//    Breakpoint.MD {
//        Modifier.padding(top = 150.px, left = 90.px)
//    }
//}
//
//val HeroContentColumnStyle = CssStyle {
//    base { Modifier.maxWidth(400.px) }
//    Breakpoint.MD { Modifier.maxWidth(600.px) }
//}
//
//val HeroTitleStyle = CssStyle {
//    base {
//        Modifier
//            .fontSize(18.px)
//            .margin(bottom = 15.px)
//    }
//    Breakpoint.MD {
//        Modifier
//            .fontSize(50.px)
//            .margin(bottom = 30.px)
//    }
//}
//
//val HeroSubtitleStyle = CssStyle {
//    base {
//        Modifier
//            .fontSize(15.px)
//            .margin(bottom = 30.px)
//    }
//    Breakpoint.MD {
//        Modifier
//            .fontSize(30.px)
//            .margin(bottom = 60.px)
//    }
//}
//
//val ResponsiveButtonStyle = CssStyle {
//    base {
//        Modifier
////            .fontSize(14.px)
////            .borderRadius(30.px)
//            .padding(topBottom = 5.px, leftRight = 10.px)
//    }
//    Breakpoint.MD {
//        Modifier
////            .fontSize(40.px)
////            .borderRadius(50.px)
//            .padding(topBottom = 45.px, leftRight = 50.px)
//    }
//}
//val SpanTextStyle =CssStyle {
//    base { Modifier.fontSize(14.px) }
//    Breakpoint.MD  { Modifier.fontSize(40.px) }
//}

val HeroContainerStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .styleModifier {
                property("background-size", "cover")
                property("background-position", "center center")
                property("min-height", "300px")
            }
    }
    Breakpoint.MD {
        Modifier
            .fillMaxWidth()
            .styleModifier {
                // Utilise 100% de la largeur sans couper l'image en haut/bas
                property("background-size", "100% 100%")
                property("background-position", "center")
                // Ajuste le ratio largeur/hauteur de ta bannière (ex: 16/9 ou 1920/800)
                property("aspect-ratio", "1920 / 750")
                property("min-height", "auto")
                property("max-height", "none")
            }
    }
}

val HeroContentBoxStyle = CssStyle {
    base {
        Modifier.padding(top = 40.px, bottom = 40.px, left = 20.px)
    }
    Breakpoint.MD {
        Modifier.padding(left = 7.percent) // Padding relatif pour suivre le redimensionnement de l'image
    }
}

val HeroContentColumnStyle = CssStyle {
    base { Modifier.maxWidth(100.percent) }
    Breakpoint.MD { Modifier.maxWidth(45.percent) } // Ne dépasse pas 45% de la largeur pour laisser voir l'illustration à droite
}

val HeroTitleStyle = CssStyle {
    base {
        Modifier
            .fontSize(18.px)
            .margin(bottom = 12.px)
    }
    Breakpoint.MD {
        Modifier
            .styleModifier { property("font-size", "clamp(24px, 2.5vw, 42px)") } // S'adapte de manière fluide à la taille d'écran
            .margin(bottom = 20.px)
    }
}

val HeroSubtitleStyle = CssStyle {
    base {
        Modifier
            .fontSize(14.px)
            .margin(bottom = 24.px)
    }
    Breakpoint.MD {
        Modifier
            .styleModifier { property("font-size", "clamp(14px, 1.4vw, 22px)") } // S'adapte de manière fluide
            .margin(bottom = 35.px)
    }
}

val ResponsiveButtonStyle = CssStyle {
    base {
        Modifier.padding(topBottom = 5.px, leftRight = 10.px)
    }
    Breakpoint.MD {
        Modifier.padding(topBottom = 45.px, leftRight = 50.px)
    }
}

val SpanTextStyle = CssStyle {
    base { Modifier.fontSize(14.px) }
    Breakpoint.MD { Modifier.fontSize(40.px) }
}